module.exports = __webpack_public_path__ + "img/blog-12.04c2e793.webp";